import { createContext } from 'react';

/**
 * Панель `Tabs` скрыта (`display: none`) — сама или внутри скрытой панели внешних вкладок. `undefined` — вне `Tabs`:
 * видимость известна только по DOM.
 */
export const TabPanelHiddenContext = createContext<boolean | undefined>(undefined);
